import { combineReducers } from 'redux';

import byId from './byId';
import configuration from './configuration';

/**
 * @typedef {{
 *   configuration: import('./configuration').NotificationDataConfigurationReducer
 * }} NotificationDataReducer
 */

export default combineReducers({
  configuration,
  byId,
});
